export default __webpack_public_path__ + "static/media/order-calendar.dce19bed.svg";